import { Require } from './Require';
export default Require;
